import StressReplayPanel from "@/components/risk/StressReplayPanel";
export default function RStress() { return <StressReplayPanel range="R" />; }
